import { Base64 } from "js-base64";
import { LoginType } from "./enum/login";

export class AdminUser {
  displayName: string;
  source: LoginType;
  artistIds: number[];
  eventId?: number;

  constructor(token: string) {
    const splitToken = token.split(".");
    if (splitToken.length === 3) {
      const data = JSON.parse(Base64.decode(splitToken[1]));
      this.displayName = data.displayName;
      this.source = data.source;
      this.artistIds = data.artistIds;
      this.eventId = data.eventId;
    } else {
      throw new Error("Can't parse token as JWT");
    }
  }
}
